import { createListBox } from './_listbox.js'
import createTimebox from './_timebox.js'
import { createDp } from './_dp.js'

const $widget = document.querySelector('.js-fast-track-widget')

if ($widget) {
  init($widget)
}

window.LBA.initFastTrackWidget = $root => {
  init($root.querySelector('.js-fast-track-widget'))
}

function init ($widget) {
  const $entryDate = document.querySelector('.js-fast-track-widget-entry-date')
  const $entryTime = document.querySelector('.js-fast-track-widget-entry-time')
  const $tickets = document.querySelector('.js-fast-track-widget-tickets')

  let entryDate, entryTime, tickets

  if ($entryDate) {
    createDp($entryDate, {
      minDate: new Date(),
      container: $entryDate.parentNode,
      numberOfMonths: 1
    })
    $entryDate.addEventListener('change', () => {
      entryDate = $entryDate.value
    })
  }

  if ($entryTime) {
    const init = async () => {
      entryTime = await createListBox($entryTime, {
        onSelect({ getValue, setValue }) {
          if (getValue) entryTime = getValue()
          checkIsValid()
        }
      })

      if (!entryTime.getValue()) {
        entryTime.setValue('00:01')
      }
    }
    init()
  }

  if ($tickets) {
    createListBox($tickets, {
      onSelect({ getValue }) {
        if (getValue) tickets = getValue()
        checkIsValid()
      }
    })
  }

  function checkIsValid() {
    if(entryDate && entryTime && tickets) {
      $widget.querySelector(".js-fast-track-widget-submit").hidden = false
    }
  }

  $widget.addEventListener('submit', e => {
    e.preventDefault()

    $widget.querySelector("[type=submit] .js-spinner").hidden = false

    let redirectUrl = ''

    let data = new window.FormData($widget),
      dataParsed = ''
    for (let pair of data.entries()) {
      if (pair[0] == 'redirectUrl') {
        redirectUrl = pair[1]
        continue
      }
      dataParsed += `${encodeURI(pair[0])}=${encodeURI(pair[1])}&`
    }

    dataParsed = dataParsed.substring(0, dataParsed.length - 1)

    return (window.location.href = `${redirectUrl}?${dataParsed}`)
  })
  // Somewhere here we need to fire this off to the backend
}



// WEBPACK FOOTER //
// ./src/js/_fast-track-widget.js